import './src/css/tailwind.css';
import "@fontsource/fredoka-one"